import {
  Anchor,
  AutoshipmentLogoMark,
  CartButton,
  P1,
  P2,
  P3,
  Rating,
} from '@zooplus/ui-components';

import styles from './Product.module.scss';
import React, { useRef, useState } from 'react';
import { useSiteContext } from '@zooplus/commons-lang';
import { getUrlLocalised, useTranslation } from '../../../hooks/use-translations';
import { ProductInfo } from '../../../model/product';
import { useCartContext } from '@zooplus/cart-provider';

export type ProductProps = {
  product: ProductInfo;
};

export const Product = ({ product }: ProductProps) => {
  const { t } = useTranslation();
  const { site } = useSiteContext();
  const { changeArticleQuantity } = useCartContext();
  const [addingToCart, setAddingToCart] = useState(false);
  const addToCartRef = useRef(null);

  function addToCart() {
    setAddingToCart(true);
    changeArticleQuantity({
      articleId: product.articleShopId,
      quantity: 1,
      subscriptionSelected: true,
      popover: addToCartRef.current ? { trigger: addToCartRef.current } : undefined,
    }).then((_) => setAddingToCart(false));
  }

  return (
    <div className={styles.productWrapper} id={`product-${product.articleShopId}`}>
      <div className={styles.image}>
        <img className={styles.imageContent} src={product.pictureUrl} alt="" />
      </div>
      <Rating
        count={product.votes}
        notRatedLabel="Not rated"
        rating={product.rating}
        ratingLabel="Rating"
        size="sm"
        className={styles.rating}
      />
      <Anchor href={getUrlLocalised(t, product.pdpUrl)} isBold target="">
        <P1 bold className={styles.productName}>
          {product.productName}
        </P1>
      </Anchor>

      <div className={styles.prices}>
        <P2 bold className={styles.price}>
          {product.originalPriceFormatted}
        </P2>
        <P3 className={styles.price}>{product.unitPriceFormatted}</P3>
        <P2 className={`${styles.price} ${styles.ausPrice}`}>
          <AutoshipmentLogoMark realm={site.realm} className={styles.icon} size="small" />
          {product.discountedPriceFormatted}
        </P2>
      </div>
      <CartButton
        id={`add-to-subscription-${product.articleShopId}`}
        key={`add-to-subscription-${product.articleShopId}`}
        className={styles.addToCart}
        size={'small'}
        withIcon
        onClick={addToCart}
        isLoading={addingToCart}
        ref={addToCartRef}
        disabled={product.disabled}>
        <P2 bold>{product.disabled ? t('product.added') : t('product.add-to-cart')}</P2>
      </CartButton>
    </div>
  );
};
